export default __webpack_public_path__ + "static/media/coupon.c3768ebc.svg";